































import Vue from "vue";

export default Vue.extend({
  name: "SoftwareMagoDisplay",
  methods: {},
  computed: {
    links() {
      const links = this.$store.getters["cms/directLinks"];
      if (!Array.isArray(links)) return links;
      const priority = (title: string): number => {
        const t = title.toLowerCase();
        if (t.includes("play")) return 0;
        if (t.includes("neat")) return 1;
        if (t.includes("fire")) return 2;
        if (t.includes("apk")) return 3;
        return 4;
      };
      return [...links].sort((a, b) => priority(a.title) - priority(b.title));
    },
  },
  async created() {
    this.$store.dispatch("cms/fetchDirectLinks");
  },
});
